import { Model, HasOne } from 'spraypaint';
import ApplicationRecord from '../../ApplicationRecord';
import type AuditsExport from '../AuditsExport';

@Model()
class AuditsExportsCockpitCityExport extends ApplicationRecord {
  static jsonapiType = 'audits-exports-cockpit_city_exports';

  // Relationships
  @HasOne('audits-exports') export!: AuditsExport;
}

export default AuditsExportsCockpitCityExport;
